module.exports = __webpack_public_path__ + "static/media/harmonic_logo.13a559e9.png";